module.exports = __webpack_public_path__ + "onboarding-communitysteps.ad436ca01223d57afec3d5f1b1e34180.hashedasset.svg";